var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.9851V23.9851H21C22.6568 23.9851 24 22.6419 24 20.9851V11.8641C24.0002 11.3446 23.7983 10.8453 23.437 10.4721L14.939 1.28504C13.4396 -0.337303 10.9089 -0.436913 9.28655 1.06253C9.20949 1.13378 9.13523 1.20798 9.06403 1.28504L0.581016 10.4691C0.208734 10.8439 -0.000140554 11.3508 7.09607e-08 11.8791V20.9851C7.09607e-08 22.6419 1.34316 23.9851 3 23.9851H6.99998V17.9851C7.01869 15.2582 9.22027 13.0315 11.8784 12.9674C14.6255 12.9011 16.9791 15.1658 17 17.9851Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.9846C10.3432 14.9846 9 16.3278 9 17.9846V23.9846H15V17.9846C15 16.3278 13.6568 14.9846 12 14.9846Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.a1c528043c013fa767234c968e52fe9e.svg";
export { ForwardRef as ReactComponent };